import React from 'react';
import classNames from 'classnames';

import styles from './Status.module.scss';

export interface StatusText {
	status: 'success' | 'warning' | 'error' | 'readyForReview' | 'darkInfo' | 'default';
}

interface StatusProps extends StatusText {
	className?: string;
}

class Status extends React.Component<StatusProps> {
	render() {
		const { status, className } = this.props;

		return (
			<div
				className={classNames(
					styles.status,
					{
						[styles.success]: status === 'success',
						[styles.warning]: status === 'warning',
						[styles.error]: status === 'error',
						[styles.readyForReview]: status === 'readyForReview',
						[styles.darkInfo]: status === 'darkInfo',
					},
					className
				)}
			>
				{this.props.children}
			</div>
		);
	}
}

export default Status;
